import React from 'react';
import { Row, Col, Tag } from 'antd';

const useFederation = (data, translate, status) => {
  const allFederation = [];
  const allImpact = [];
  if (data && data.plan_com[data.plan_com.length - 1] !== null) {
    data.plan_com[data.plan_com.length - 1].deliverables_plan_com.forEach(
      (event) => {
        if (event.federation && event.impact) {
          allFederation.push(event?.federation * event?.impact);

          allImpact.push(event?.impact);
        }
      }
    );
    if (allFederation.length > 1)
      return (
        <Row style={{ marginBottom: 8 }} justify="start">
          <Col span={24}>
            <span
              style={{
                textTransform: 'uppercase',
                letterSpacing: '.10em',
                fontSize: 10,
                color: '#8c8c8c'
              }}
            >
              {translate(`projects.details.membership`)}
            </span>
          </Col>
          <Col span={24}>
            {`${Math.round(
              allFederation.reduce((a, b) => a + b, 0) /
                allImpact.reduce((a, b) => a + b, 0)
            )} %`}
          </Col>
        </Row>
      );
  }

  return (
    <>
      <Col>
        <span
          style={{
            textTransform: 'uppercase',
            letterSpacing: '.10em',
            fontSize: 10,
            color: '#8c8c8c'
          }}
        >
          {translate(`projects.details.membership`)}
        </span>
        <Tag color="orange" style={{ marginRight: 16 }}>
          Non saisi
        </Tag>
      </Col>
    </>
  );
};

export default useFederation;
